// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1868":"e1ead11b4456dad8","6022":"8969fd31f3a473f3"}[chunkId] + ".css";
};